'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typography = require('./styles/typography');

var _colors = require('./styles/colors');

var _reactIcons = require('@rover/react-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pill = function (_Component) {
    _inherits(Pill, _Component);

    function Pill(props) {
        _classCallCheck(this, Pill);

        var _this = _possibleConstructorReturn(this, (Pill.__proto__ || Object.getPrototypeOf(Pill)).call(this, props));

        _this.state = {
            deleteButtonColor: ''
        };
        _this.isHighlightPill = _this.isHighlightPill.bind(_this);
        return _this;
    }

    _createClass(Pill, [{
        key: 'handleMouseEventPill',
        value: function handleMouseEventPill(type) {
            if (!this.isHighlightPill()) {
                if (type === 'over') {
                    this.setState({
                        deleteButtonColor: _colors.steel
                    });
                } else if (type === 'leave') {
                    this.setState({
                        deleteButtonColor: ''
                    });
                }
            }
        }
    }, {
        key: 'isHighlightPill',
        value: function isHighlightPill() {
            var _props = this.props,
                onHighlight = _props.onHighlight,
                index = _props.index,
                highlightIndex = _props.highlightIndex;

            return onHighlight && index === highlightIndex;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                height = _props2.height,
                icon = _props2.icon,
                backgroundColor = _props2.backgroundColor,
                tagIconColor = _props2.tagIconColor,
                textColor = _props2.textColor,
                deleteButtonBackground = _props2.deleteButtonBackground,
                deleteButtonColor = _props2.deleteButtonColor,
                onHighlight = _props2.onHighlight,
                onHighlightBackgroundColor = _props2.onHighlightBackgroundColor,
                onHighlightTagIconColor = _props2.onHighlightTagIconColor,
                onHighlightTextColor = _props2.onHighlightTextColor,
                onHighlightDeleteButtonBackground = _props2.onHighlightDeleteButtonBackground,
                onHighlightDeleteButtonColor = _props2.onHighlightDeleteButtonColor,
                onHoverDeleteButtonBackground = _props2.onHoverDeleteButtonBackground,
                onHoverDeleteButtonColor = _props2.onHoverDeleteButtonColor,
                maxWidth = _props2.maxWidth;


            var getIconFill = function getIconFill() {
                return _this2.isHighlightPill() ? onHighlightTagIconColor : tagIconColor;
            };
            var getBackgroundColor = function getBackgroundColor() {
                return _this2.isHighlightPill() ? onHighlightBackgroundColor : backgroundColor;
            };

            var getTextColor = function getTextColor() {
                return _this2.isHighlightPill() ? onHighlightTextColor : textColor;
            };

            var getDeleteButtonColor = function getDeleteButtonColor() {
                return _this2.isHighlightPill() ? onHighlightDeleteButtonColor : deleteButtonColor;
            };

            var tagIcon = function tagIcon() {
                return _react2.default.createElement(
                    'div',
                    {
                        style: {
                            marginLeft: 11,
                            marginRight: 8,
                            width: 12,
                            height: 12
                        }
                    },
                    icon && _react2.default.createElement(_reactIcons.TagIcon, {
                        fill: getIconFill(),
                        style: {
                            pointerEvents: 'none',
                            transform: 'scale(.75)'
                        }
                    })
                );
            };

            var getText = function getText() {
                return _react2.default.createElement(
                    'div',
                    {
                        style: _extends({
                            display: 'inline-block'
                        }, _typography.text, _typography.light, {
                            fontSize: 14,
                            color: getTextColor(),
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minWidth: 0,
                            maxWidth: maxWidth - 65
                        })
                    },
                    _this2.props.text
                );
            };

            var getDeleteButton = function getDeleteButton() {
                return _react2.default.createElement(
                    'div',
                    {
                        style: {
                            height: 16,
                            width: 16,
                            marginLeft: 8,
                            marginRight: 6,
                            background: _this2.state.deleteButtonColor,
                            borderRadius: 23,
                            display: 'flex',
                            flex: 'none',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        onMouseDown: function onMouseDown() {
                            return _this2.props.updateTags(null, 'delete', _this2.props.index);
                        }
                    },
                    _react2.default.createElement(_reactIcons.CancelIcon, { fill: getDeleteButtonColor(), style: { pointerEvents: 'none' } })
                );
            };
            return _react2.default.createElement(
                'div',
                {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: height,
                        backgroundColor: getBackgroundColor(),
                        borderRadius: 23,
                        marginRight: 8,
                        marginTop: 4,
                        marginBottom: 4
                    },
                    onMouseOver: function onMouseOver(e) {
                        return _this2.handleMouseEventPill('over');
                    },
                    onMouseLeave: function onMouseLeave(e) {
                        return _this2.handleMouseEventPill('leave');
                    }
                },
                tagIcon(),
                getText(),
                getDeleteButton()
            );
        }
    }]);

    return Pill;
}(_react.Component);

Pill.propTypes = {
    height: _propTypes2.default.number,
    icon: _propTypes2.default.bool,
    text: _propTypes2.default.string.isRequired,
    maxWidth: _propTypes2.default.number.isRequired,
    backgroundColor: _propTypes2.default.string,
    tagIconColor: _propTypes2.default.string,
    textColor: _propTypes2.default.string,
    deleteButtonBackground: _propTypes2.default.string,
    deleteButtonColor: _propTypes2.default.string,
    onHighlight: _propTypes2.default.bool,
    onHighlightBackgroundColor: _propTypes2.default.string,
    onHighlightTagIconColor: _propTypes2.default.string,
    onHighlightTextColor: _propTypes2.default.string,
    onHighlightDeleteButtonColor: _propTypes2.default.string,
    onHighlightDeleteButtonBackground: _propTypes2.default.string,
    onHoverDeleteButtonBackground: _propTypes2.default.string,
    onHoverDeleteButtonColor: _propTypes2.default.string,
    index: _propTypes2.default.number,
    highlightIndex: _propTypes2.default.number,
    updateTags: _propTypes2.default.func
};

Pill.defaultProps = {
    height: 28,
    icon: true,
    text: 'Hiking',
    //defaultState
    backgroundColor: _colors.ash,
    tagIconColor: _colors.silver,
    textColor: _colors.titanium,
    deleteButtonBackground: null,
    deleteButtonColor: _colors.silver,
    //onHighlightState
    onHighlight: false,
    onHighlightBackgroundColor: _colors.straw,
    onHighlightTagIconColor: _colors.ash,
    onHighlightTextColor: _colors.graphite,
    onHighlightDeleteButtonBackground: null,
    onHighlightDeleteButtonColor: _colors.steel,
    //onHover
    onHoverDeleteButtonBackground: _colors.steel,
    onHoverDeleteButtonColor: 'white',
    maxWidth: 370,
    index: null,
    highlightIndex: null,
    updateTags: function updateTags() {
        return null;
    }
};

exports.default = Pill;
//# sourceMappingURL=Pill.js.map